jQuery(function ($) {
  const header = document.querySelector('header');

  const searchClient = algoliasearch(
    "LFO6MNL7X1",
    "5c4baef17a8a1010cd8a61180d16a289"
  );
  const search = instantsearch({
    indexName: "global",
    searchClient,
  });

  if (header) {

    const ribbon = $('.header .ribban-bar');
    const ribbonCross = $('.header .ribban-bar .cross');
    const searchIcon = $('.header .top-nav .search');
    const crossSerchBtn = $('.header .close-icon');
    const textInput = $('.header #mobile-search-box');
    const ribbonPara = $('.header .ribban-bar .conten-wrap p');

    function drupalLogin() {
      var winWidth = $(window).width();
      const dropalLogin = $('body#admin-logged-in');
      const toolbar = $('body #toolbar-administration #toolbar-bar');
      const toolbarLink = $('body #toolbar-administration #toolbar-bar .toolbar-tab #toolbar-item-administration-tray');
      const toolbarLinkSub = $('body #toolbar-administration #toolbar-bar .toolbar-tab #toolbar-item-administration-tray');
      const headerHeight = $('body header');
      const totalToolBar = toolbar.innerHeight() + toolbarLinkSub.innerHeight();
      var pageMarginTop = toolbar.innerHeight() + headerHeight.innerHeight();

      if (winWidth > 991) {
        const expirationTime = 24 * 60 * 60 * 1000;
        const ribbonCache = JSON.parse(localStorage.getItem("ribbonCache"));
        if (ribbonCache) {
          const currentTime = Date.now();

          // Check if the cache is valid
          if (currentTime - ribbonCache.timestamp < expirationTime) {

            var pageMarginTopMinus = pageMarginTop - 75;
            $('body').css('margin-top', pageMarginTopMinus);
            $('body header').css('top', totalToolBar);
          } else {
            // If expired, remove the cache
            localStorage.removeItem("ribbonCache");

          }
        } else {
          if (dropalLogin.length > 0) {
            $('body').css('top', pageMarginTop);
            $('body').css('padding-top', '40px');
            $('body header').css('top', totalToolBar);
            // if(toolbarLink.classList.contain('.is-active')) {
            //     $('body.page').css('padding-top', '40px');
            // }
          } else {
            $('body').css('top', pageMarginTop);
            $('body header').css('top', totalToolBar);
            $('header').closest('.page').addClass('removeRibbon');
            $('header .main-header').addClass('addjustHeader');
          }
        }
      } else {
        if (dropalLogin.length > 0) {
          $('body').css('top', pageMarginTop);
          $('body').css('margin-top', '0');
          $('body').css('padding-top', '0');
          $('body header').css('top', toolbar.innerHeight());
        } else {
          $('body').css('top', pageMarginTop);
          $('body').css('margin-top', '0');
          $('body header').css('top', toolbar.innerHeight());
        }

      }
    }

    // function drupalLoginClick() {
    //     const toolbarLink = $('#admin-logged-in #toolbar-administration #toolbar-bar .toolbar-tab .toolbar-icon');
    //    $(toolbarLink).on('click', function () {
    //     if($(this).hasClass('is-active')) {
    //         $(this).closest('body').addClass('removePadding');
    //     } else {
    //         $(this).closest('body').addClass('removePadding');
    //     }
    //    })
    // }

    function hamburgerFacet() {
      const hamburger = $('.header .hamburger')
      hamburger.off('click').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $(this).closest('.nav').find('.main-nav-wrap').removeClass('activeMenu');
        } else {
          if ($(this).closest('body').hasClass('search-active')) {
            $(this).closest('body').removeClass('search-active');
          }
          $(this).addClass('active');
          $(this).closest('.nav').find('.main-nav-wrap').addClass('activeMenu');
        }
      });
    }
    $(document).ready(function () {
      var winWidth = $(window).width();
      hamburgerFacet();
      ribbonFacet()
      searchFacet()
      crossSerchBtnFacet()
      mouseEnterFacet(winWidth);
      drupalLogin()
      externalLink();
      // drupalLoginClick();
      docClickHandler();
    })
    $(window).resize(function () {
      var winWidth = $(window).width();
      hamburgerFacet();
      ribbonFacet()
      searchFacet()
      crossSerchBtnFacet()
      mouseEnterFacet(winWidth);
      drupalLogin();
      // drupalLoginClick();
      docClickHandler();
      const subMenu = $('header .main-nav > ul > li');
      const hamburger = $('.header .hamburger');
      setTimeout(() => {
        if ($(subMenu).find('.subMenu').hasClass('mobileActiveSubmenu')) {
          $(subMenu).find('.subMenu').removeClass('mobileActiveSubmenu');
          $(subMenu).find('a.arrow, p.arrow').removeClass('rotate');
        }
      }, 500);
      $(hamburger).removeClass('active');
      $(hamburger).closest('.header').find('.main-nav-wrap').removeClass('activeMenu');
      const crossSerchBtn = $('.header .close-icon');
      $(crossSerchBtn).closest('body').removeClass('search-active');
    })

    function mouseEnterFacet(winWidth) {
      const subMenu = $('header .main-nav > ul > li');
      const hamburger = $('.header .hamburger');
      const mobileSearch = $('.header .mobile-icons .search');
      $(subMenu).off('mouseenter mouseleave click');
      if (winWidth > 991) {
        $(subMenu).mouseenter(function () {
          $(this).find('.subMenu').addClass('active');
          $(this).find('a.arrow').addClass('rotate');
        });
        $(subMenu).mouseleave(function () {
          $(this).find('.subMenu').removeClass('active');
          $(this).find('a.arrow').removeClass('rotate');
        })
      } else {
        $(subMenu).click(function (e) {
          const attr = $(e.target).attr('class');
          if ($(this).find('.subMenu').hasClass('mobileActiveSubmenu')) {
            setTimeout(() => {
              $(this).find('.subMenu').removeClass('mobileActiveSubmenu');
              $(this).find('a.arrow, p.arrow').removeClass('rotate');
            }, 500);
          } else {
            $('.subMenu').removeClass('mobileActiveSubmenu');

            setTimeout(() => {
              $(subMenu).find('a.arrow, p.arrow').removeClass('rotate');
              $(this).find('.subMenu').addClass('mobileActiveSubmenu');
              $(this).find('a.arrow, p.arrow').addClass('rotate');
            }, 500);
          }
        });
        $(mobileSearch).click(function () {
          if ($(hamburger).hasClass('active')) {
            $(hamburger).removeClass('active');
            $(this).closest('.header').find('.main-nav-wrap').removeClass('activeMenu');
            $(this).closest('body').addClass('search-active');
          } else {
            $(this).closest('body').addClass('search-active');
          }
        })
      }
    }
    function ribbonFacet() {
      if (ribbon) {
        const dropalLogin = $('body#admin-logged-in');
        const toolbar = $('body #toolbar-administration #toolbar-bar');
        const toolbarLinkSub = $('body #toolbar-administration #toolbar-bar .toolbar-tab #toolbar-item-administration-tray');
        const headerHeight = $('body header');
        const totalToolBar = toolbar.innerHeight() + toolbarLinkSub.innerHeight();
        var pageMarginTop = toolbar.innerHeight() + headerHeight.innerHeight();
        if (ribbonPara.length > 0) {
          $('header').closest('.page').removeClass('removeRibbon');
          $('header .main-header').removeClass('addjustHeader');
        } else {
          if (dropalLogin) {
            $('body').css('top', pageMarginTop);
            $('body header').css('top', totalToolBar);
            // $('header').closest('.page').addClass('removeRibbon');
            // $('header .main-header').addClass('addjustHeader');
          } else {

            $('heade ').closest('.page').addClass('removeRibbon');
            $('header .main-header').addClass('addjustHeader');
          }
        }


        const expirationTime = 24 * 60 * 60 * 1000;

        // Check if the ribbonCache is present in localStorage
        const ribbonCache = JSON.parse(localStorage.getItem("ribbonCache"));
        if (ribbonCache) {
          const currentTime = Date.now();

          // Check if the cache is valid
          if (currentTime - ribbonCache.timestamp < expirationTime) {
            $('header').find('.ribban-bar ').css('display', 'none');
            $('header').closest('.page').addClass('removeRibbon');
            $('header .main-header').addClass('addjustHeader');
          } else {
            // If expired, remove the cache
            localStorage.removeItem("ribbonCache");
          }
        } else {
          if (ribbonPara.length > 0) {
            $('header .main-header').css('margin-top', '40px');
            setTimeout(() => {
              $('header').find('.ribban-bar ').css('display', 'block');
            }, 100)
          }
        }

        $(ribbonCross).click(function () {

          $(this).closest('body').addClass('removeRibbon');
          $(this).closest('.ribban-bar ').css('display', 'none');
          $(this).closest('body').find('header .main-header').css('margin-top', '0');
          $(this).closest('body').find('header .main-header').addClass('addjustHeader');

          // Store the timestamp in localStorage to cache the state
          var ribbonHeader = 'ribbonHeader'
          localStorage.setItem(
            "ribbonCache",
            JSON.stringify({
              ribbonCache: "ribbonHeader", // Custom value
              timestamp: Date.now(), // Add current time
            })
          );
          drupalLogin();
        })
      }
    }

    function searchFacet() {
      if (searchIcon) {
        const hamburger = $('.header .hamburger')
        $(searchIcon).click(function (e) {
          var windowWidth = $(window).width();
          e.preventDefault()
          if ($(hamburger).hasClass('active')) {
            $(hamburger).removeClass('active');
            $(this).closest('.header').find('.main-nav-wrap').removeClass('activeMenu');
            $(this).closest('body').addClass('search-active');
          } else {
            const inputSearch = document.querySelector('.header .search-box .wrap #nav-search .ais-SearchBox .ais-SearchBox-form input');

            setTimeout(() => {
              inputSearch.focus();
            }, 100);
            inputSearch.value = "";
            if (windowWidth > 991) {
              // Add the search-active class to the body
              $(this).closest('body').addClass('search-active');
            }
            // }
          }
        })
      }
    }

    function crossSerchBtnFacet() {
      if (crossSerchBtn) {
        $(crossSerchBtn).click(function () {
          $(this).closest('body').removeClass('search-active');
        })
      }
    }
    if (textInput) {
      $(textInput).on('keyup', function () {
        if (this.value.length > 0) {
          $(this).closest('form').find('#mobile-search-reset').addClass('showResetBtn');
        } else {
          $(this).closest('form').find('#mobile-search-reset').removeClass('showResetBtn');
        }
      });
    }
    const resetInputText = $('.header form #mobile-search-reset');
    if (resetInputText) {
      $(resetInputText).click(function () {
        $(this).closest('form').find('input').val('');
        $(this).closest('form').find('#mobile-search-reset').removeClass('showResetBtn');
      })
    }

    function externalLink() {
      const subMenu = $('header .main-nav .desktop-nav > li, header .main-nav .mobile-nav > li');
      const topNav = $('header .main-nav-wrap .top-nav ul > li');
      const topMobileNav = $('header .main-nav .mobile-bottom-links ul > li');

      if (topNav.length > 0) {
        for (let index = 0; index < topNav.length; index++) {
          const topElement = topNav[index];
          const topLink = $(topElement).find('a').attr('href');
          if (topLink) {
            try {
              const url = new URL(topLink);
              if (url.hostname != window.location.hostname) {

                $(topElement).find('a').attr('target', '_blank');
                $(topElement).find('a').addClass('externalTopLink');
              }
            } catch (error) {
              $(topElement).find('a').removeClass('externalTopLink');
            }
          } else {
            console.log('No href attribute found');
          }
        }
      }
      if (topMobileNav.length > 0) {
        for (let index = 0; index < topMobileNav.length; index++) {
          const topMobileElement = topMobileNav[index];
          const topMobileLink = $(topMobileElement).find('a').attr('href');
          if (topMobileLink) {
            try {
              const url = new URL(topMobileLink);
              if (url.hostname != window.location.hostname) {

                $(topMobileElement).find('a').attr('target', '_blank');
                $(topMobileElement).find('a').addClass('externalTopMobileLink');
              }
            } catch (error) {
              $(topMobileElement).find('a').removeClass('externalTopMobileLink');
            }
          } else {
            console.log('No href attribute found');
          }
        }
      }
      if (subMenu.length > 0) {
        for (let index = 0; index < subMenu.length; index++) {
          const element = subMenu[index];
          const link = $(element).find('a').attr('href');
          const extrSubMenu = $(element).find('.subMenu .menuWrap > ul li');
          if (extrSubMenu.length > 0) {
            for (let index = 0; index < extrSubMenu.length; index++) {
              const element = extrSubMenu[index];
              const subLink = $(element).find('a').attr('href');
              if (subLink) {
                try {
                  const url = new URL(subLink);
                  if (url.hostname != window.location.hostname) {

                    $(element).find('a').attr('target', '_blank');
                    $(element).find('a').addClass('externalLink');
                  }
                } catch (error) {
                  $(element).find('a').removeClass('externalLink');
                }
              } else {
                console.log('No href attribute found');
              }
            }
          }
        }
      }
    }

    function docClickHandler() {
      document.addEventListener('click', function (e) {
        const dropShadowSelector = '.header .search-box .drop-shadow';
        const closestBody = e.target.closest('body');

        if (closestBody) {
          const dropShadow = closestBody.querySelector(dropShadowSelector);
          if (dropShadow && e.target !== dropShadow) {
            dropShadow.classList.add('hide');
          }
        }
      });
    }




  }

  if (header) {
    const renderIndexListItem = ({ indexId, hits }) => `
            ${hits
        .slice(0, 5)
        .map(
          (hit, hitIndex) =>
            `
                    <li>
                    ${hit.title ? `<p><a href="/search?query=${hit.title}">${instantsearch.highlight({ attribute: "title", hit })}</a></p>` : ""}
                    ${hit.taxonomy_name ? `<p><a href="/search?query=${hit.taxonomy_name}">${instantsearch.highlight({ attribute: "taxonomy_name", hit })}</a></p>` : ""}
                    </li>
                `
        )
        .join("")}
       `;

    // Create the render function
    const renderAutocomplete = (renderOptions, isFirstRender) => {
      const { indices, currentRefinement, refine, widgetParams } = renderOptions;
      if (isFirstRender) {
        const input = document.createElement("input");
        const ul = document.createElement("ul");
        input.addEventListener("input", (event) => {
          refine(event.currentTarget.value);
        });

        widgetParams.container.appendChild(input);
        widgetParams.container.appendChild(ul);

        ul.addEventListener("click", (event) => {
          const text = event.target.textContent;
          const element = document.querySelector(
            "#nav-search .ais-SearchBox-input"
          );

          element.value = text;
          var event = new Event("input", {
            bubbles: true,
            cancelable: true,
          });
          element.dispatchEvent(event);
          const autocomplete = document.getElementById("nav_autocomplete");
          autocomplete.classList.add("hide");
        });
      }

      widgetParams.container.querySelector("input").value = currentRefinement;
      widgetParams.container.querySelector("ul").innerHTML = indices
        .map(renderIndexListItem)
        .join("");
    };

    // Create the custom widget
    const customAutocomplete = instantsearch.connectors.connectAutocomplete(renderAutocomplete);

    // Algolia pass query id to product page
    function getqueryIDfromAutocomplete(query_ID, object_ID, position) {
      queryURL =
        "?objectID=" +
        object_ID +
        "&queryID=" +
        query_ID +
        "&position=" +
        position;
      return queryURL;
    }

    // Check if query id is generated from autocomplete
    function checkqueryIDisAvailable(query_ID) {
      return query_ID;
    }
    let timerId;
    search.addWidgets([
      /*
      Declare input search
      */
      instantsearch.widgets.configure({
        filters: 'NOT type:"product_child" AND NOT type:"page" ',
      }),

      instantsearch.widgets.searchBox({
        container: "#nav-search",
        placeholder: "What do you want to find?",
        showSubmit: false,
        showLoadingIndicator: false,
        searchAsYouType: false,
        // queryHook(query, refine) {
        //   clearTimeout(timerId)
        //   timerId = setTimeout(() => refine(query), 3000)
        // },
      }),
      instantsearch.widgets.hits({
        container: "#nav_hits",
        transformItems(items) {
          return items.map((item) => ({
            ...item,
            queryUrl: getqueryIDfromAutocomplete(
              item.__queryID,
              item.objectID,
              item.__position
            ),
          }));
        },

      }),

      customAutocomplete({
        container: document.querySelector("#nav_autocomplete"),
        stallThreshold: 3000,
      }),

    ]).on("render",()=>{
      console.log("object")
      setTimeout(() => {
        const inpVal = document.querySelector("#nav-search .ais-SearchBox-input").value
       
        if(inpVal){
          const autocomplete = document.getElementById("nav_autocomplete");
          autocomplete.classList.remove("hide");
        }
             
      }, 1000);
    });
    search.start();



    setTimeout(() => {
      const element = document.querySelector("#nav-search .ais-SearchBox-input");
      const searchSubmitIcon = document.querySelector("#nav-search #mobile-search-submit");

      searchSubmitIcon.addEventListener("click", function (event) {
        event.preventDefault()
        const inputValue = element.value;
        event.preventDefault();
        window.location = `/search/?query=${inputValue}`;
      });
      element.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
          const inputValue = event.target.value;
          event.preventDefault();
          window.location = `/search/?query=${inputValue}`;
        }
      });
      let bodyElem = document.querySelector("body")
      element.addEventListener("click", function (event) {
        if (window.innerWidth < 767 && bodyElem.classList.contains("android")) {
          var getNavSearch = setInterval(() => {
            let body = document.querySelector("body")
            if (!body.classList.contains("search-active")) {
              clearInterval(getNavSearch)
              body.classList.add('search-active');
            }
          }, 10)
        }
      });

      element.oninput = function (event) {
        const inputValue = this.value;
        //localStorage.setItem('searchText', inputValue);
        var reset = document.querySelector(".search-box [type='reset']");
        const autocomplete = document.getElementById("nav_autocomplete");

        if (inputValue.length > 0) {
          if (autocomplete.classList.contains("hide")) {
            reset.classList.remove("hide");
            // setTimeout(() => {
            //   autocomplete.classList.remove("hide");
            //   reset.classList.remove("hide");
            // }, 4000);
          }
        } else {
          setTimeout(() => {
            autocomplete.classList.add("hide");
            reset.classList.add("hide");
          }, 4000);
        }
        const searchWrap = document.getElementById("nav-search");
        if (inputValue.length == 0) {
        } else if (searchWrap.classList.contains("hide") && inputValue.length > 0) {
          searchWrap.classList.remove("hide");
        }
      };
      const form = document.querySelector("#nav-search form");
      form.addEventListener("submit", function () {
        const autocomplete = document.getElementById("nav_autocomplete");
        autocomplete.classList.add("hide");
      });
      const resetSearch = document.querySelector(
        "#nav-search .ais-SearchBox-reset"
      );
      resetSearch.addEventListener("click", function () {
        const autocomplete = document.getElementById("nav_autocomplete");
        autocomplete.classList.add("hide");
      })
    }, 1000);
  }

});
